(() => {
  // shopify/v454-cart-gate/botanicals-handoff.mjs
  var STOREFRONT_ORIGIN = "https://shop.innervital.com";
  var LOGIN_PATH = "/customer_authentication/login";
  function validateShopifyAccountHandoff(value, verifiedEmail, previewThemeId = null) {
    if (!value || typeof value.location !== "string" || typeof verifiedEmail !== "string") throw new Error("BOTANICALS_HANDOFF_REJECTED");
    const email = verifiedEmail.trim().toLowerCase(), logout = new URL(value.location);
    if (logout.origin !== STOREFRONT_ORIGIN || logout.pathname !== "/account/logout" || logout.username || logout.password || logout.hash || [...logout.searchParams.keys()].length !== 1 || logout.searchParams.getAll("return_url").length !== 1) throw new Error("BOTANICALS_HANDOFF_REJECTED");
    const target = logout.searchParams.get("return_url");
    if (!target.startsWith(LOGIN_PATH + "?")) throw new Error("BOTANICALS_HANDOFF_REJECTED");
    const url = new URL(target, STOREFRONT_ORIGIN);
    const keys = [...url.searchParams.keys()];
    if (url.origin !== STOREFRONT_ORIGIN || url.pathname !== LOGIN_PATH || url.username || url.password || url.hash || keys.length !== 2 || !keys.includes("return_to") || !keys.includes("login_hint") || url.searchParams.getAll("return_to").length !== 1 || url.searchParams.get("return_to") !== (previewThemeId ? "/?preview_theme_id=" + previewThemeId : "/") || url.searchParams.getAll("login_hint").length !== 1 || url.searchParams.get("login_hint")?.trim().toLowerCase() !== email) {
      throw new Error("BOTANICALS_HANDOFF_REJECTED");
    }
    return logout.href;
  }

  // shopify/v454-cart-gate/cart-core.mjs
  var SHOP = "https://shop.innervital.com";
  var VIEW = "iv-portal-handoff";
  var PENDING = "iv.portal.cart-handoff.v454";
  var EPOCH = "iv.portal.cart-epoch.v454";
  var TTL = 30 * 60 * 1e3;
  function parseCartHandoff(href, themeId2 = null) {
    const url = new URL(href), params = new URLSearchParams(url.hash.slice(1)), preview = url.searchParams.get("preview_theme_id");
    if (preview && preview !== themeId2) throw Error("PREVIEW_THEME_INVALID");
    if (url.origin !== SHOP || url.pathname !== "/" || url.username || url.password || url.search !== "?view=" + VIEW + (preview ? "&preview_theme_id=" + preview : "") || params.getAll("logout").length !== 1 || [...params.keys()].some((k) => !["logout", "complete"].includes(k)) || params.getAll("complete").length > 1) throw Error("HANDOFF_INVALID");
    const target = params.get("logout");
    if (!target?.startsWith("/account/logout?")) throw Error("HANDOFF_INVALID");
    const logout = new URL(target, SHOP), login = new URL(logout.searchParams.get("return_url"), SHOP), email = login.searchParams.get("login_hint");
    const effectivePreview = login.searchParams.get("return_to") === "/?preview_theme_id=" + themeId2 ? themeId2 : preview;
    validateShopifyAccountHandoff({ location: logout.href }, email, effectivePreview);
    const complete = params.get("complete");
    if (complete !== null && !/^[a-f0-9-]{36}$/.test(complete)) throw Error("HANDOFF_INVALID");
    const start = new URL("/?view=" + VIEW, SHOP);
    if (effectivePreview) start.searchParams.set("preview_theme_id", effectivePreview);
    start.hash = new URLSearchParams({ logout: logout.pathname + logout.search }).toString();
    return { logout: logout.href, email: email.trim().toLowerCase(), complete, start: start.href };
  }
  function readPending(storage2, now = Date.now(), themeId2 = null) {
    let p;
    try {
      p = JSON.parse(storage2.getItem(PENDING) || "null");
    } catch {
      return null;
    }
    if (!p) return null;
    try {
      const parsed = parseCartHandoff(p.start, themeId2);
      if (p.version !== 1 || !["CLEARING", "AUTHENTICATING"].includes(p.stage) || !Number.isFinite(p.created) || now - p.created < 0 || now - p.created > TTL || !/^[a-f0-9-]{36}$/.test(p.attempt) || parsed.email !== p.email || parsed.logout !== p.logout || parsed.complete) throw Error();
      return p;
    } catch {
      storage2.removeItem(PENDING);
      return null;
    }
  }
  async function clearAndVerifyCart({ fetchImpl = fetch, root: root2 = "/", signal } = {}) {
    if (!/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?$/.test(root2)) throw Error("CART_ROOT_INVALID");
    const options = { credentials: "same-origin", cache: "no-store", redirect: "error", signal };
    const cleared = await fetchImpl(root2 + "cart/clear.js", { ...options, method: "POST", headers: { "content-type": "application/json", accept: "application/json" }, body: "{}" });
    if (!cleared.ok) throw Error("CART_CLEAR_FAILED");
    const c = await cleared.json();
    if (c.item_count !== 0 || !Array.isArray(c.items) || c.items.length !== 0) throw Error("CART_NOT_EMPTY");
    const read = await fetchImpl(root2 + "cart.js", { ...options, method: "GET", headers: { accept: "application/json" } });
    if (!read.ok) throw Error("CART_VERIFY_FAILED");
    const cart = await read.json();
    if (cart.item_count !== 0 || !Array.isArray(cart.items) || cart.items.length !== 0) throw Error("CART_NOT_EMPTY");
    return { itemCount: 0, lines: 0 };
  }
  async function runCartHandoff({ href, storage: storage2, customerEmail: customerEmail2 = "", fetchImpl, root: root2 = "/", now = Date.now(), uuid = () => crypto.randomUUID(), replace, signal, themeId: themeId2 = null }) {
    const parsed = parseCartHandoff(href, themeId2);
    let p = readPending(storage2, now, themeId2);
    if (parsed.complete) {
      if (!p || p.attempt !== parsed.complete || p.start !== parsed.start || p.stage !== "AUTHENTICATING" || customerEmail2.trim().toLowerCase() !== p.email) throw Error("HANDOFF_RESUME_INVALID");
    } else {
      p = { version: 1, stage: "CLEARING", created: now, attempt: uuid(), start: parsed.start, logout: parsed.logout, email: parsed.email };
      storage2.setItem(PENDING, JSON.stringify(p));
      if (readPending(storage2, now, themeId2)?.attempt !== p.attempt) throw Error("STORAGE_REQUIRED");
    }
    await clearAndVerifyCart({ fetchImpl, root: root2, signal });
    if (signal?.aborted) throw Error("HANDOFF_INTERRUPTED");
    storage2.setItem(EPOCH, uuid());
    if (parsed.complete) {
      storage2.removeItem(PENDING);
      replace(SHOP + "/" + (new URL(parsed.start).searchParams.has("preview_theme_id") ? "?preview_theme_id=" + themeId2 : ""));
      return "COMPLETE";
    }
    storage2.setItem(PENDING, JSON.stringify({ ...p, stage: "AUTHENTICATING" }));
    replace(parsed.logout);
    return "AUTHENTICATING";
  }
  function continuationUrl(p, customerEmail2) {
    const target = new URL(p.start);
    if (p.stage === "AUTHENTICATING" && customerEmail2.trim().toLowerCase() === p.email) {
      const hash = new URLSearchParams(target.hash.slice(1));
      hash.set("complete", p.attempt);
      target.hash = hash.toString();
    }
    return target.href;
  }
  function needsCartSnapshotRefresh(initialEpoch2, currentEpoch, persisted) {
    return Boolean(persisted && currentEpoch && currentEpoch !== initialEpoch2);
  }

  // shopify/v454-cart-gate/cart-browser.mjs
  var tag = document.currentScript;
  var themeId = tag?.dataset.themeId || null;
  var root = tag?.dataset.root || "/";
  var customerEmail = tag?.dataset.customerEmail || "";
  var isHandoff = location.pathname === "/" && new URL(location.href).searchParams.get("view") === VIEW;
  var storage;
  try {
    storage = window.sessionStorage;
  } catch {
  }
  var initialEpoch;
  try {
    initialEpoch = storage?.getItem(EPOCH);
  } catch {
  }
  var conceal = () => {
    document.documentElement.style.visibility = "hidden";
  };
  if (isHandoff) {
    let controller, busy = false;
    const start = async () => {
      if (busy) return;
      busy = true;
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 25e3);
      const status = document.getElementById("iv-cart-status"), retry = document.getElementById("iv-cart-retry");
      retry.hidden = true;
      status.textContent = "Preparing an empty cart for your Portal account\u2026";
      try {
        if (!storage) throw Error("STORAGE_REQUIRED");
        await runCartHandoff({ href: location.href, storage, customerEmail, root, themeId, signal: controller.signal, replace: (url) => location.replace(url) });
      } catch {
        status.textContent = "We could not verify an empty cart. Sign-in has not continued. Retry this handoff or return to your Portal.";
        retry.hidden = false;
      } finally {
        clearTimeout(timeout);
        busy = false;
      }
    };
    document.addEventListener("DOMContentLoaded", () => {
      document.getElementById("iv-cart-retry").addEventListener("click", start);
      void start();
    }, { once: true });
    window.addEventListener("pagehide", () => controller?.abort());
    window.addEventListener("pageshow", (e) => {
      if (e.persisted) void start();
    });
  } else if (storage) {
    const resume = () => {
      let pending;
      try {
        pending = readPending(storage, Date.now(), themeId);
      } catch {
        return;
      }
      if (pending) {
        conceal();
        location.replace(continuationUrl(pending, customerEmail));
      }
    };
    resume();
    window.addEventListener("pageshow", (e) => {
      let current;
      try {
        current = storage.getItem(EPOCH);
      } catch {
        return;
      }
      if (needsCartSnapshotRefresh(initialEpoch, current, e.persisted)) {
        conceal();
        location.reload();
        return;
      }
      resume();
    });
  }
})();
